export enum SortUpdateDirectionEnum {
  UP = 'up',
  DOWN = 'down'
}
